/**
 * Casillas que reciben avisos por correo: compras (MAIL-05) y alerta de
 * pedidos sin tomar (ADM-09).
 */
import type {
  ActualizarDestinatarioAvisoVentaDto,
  AgregarDestinatarioAvisoVentaDto,
  DestinatarioAvisoVenta,
} from '@elcarpintero/compartido';

import { pedir } from './cliente-api';

export function obtenerDestinatariosAvisoVenta(
  senal?: AbortSignal,
): Promise<DestinatarioAvisoVenta[]> {
  return pedir<DestinatarioAvisoVenta[]>('/admin/avisos-venta', { ...(senal ? { senal } : {}) });
}

export function agregarDestinatarioAvisoVenta(
  datos: AgregarDestinatarioAvisoVentaDto,
): Promise<DestinatarioAvisoVenta> {
  return pedir<DestinatarioAvisoVenta>('/admin/avisos-venta', { metodo: 'POST', cuerpo: datos });
}

export function actualizarDestinatarioAvisoVenta(
  id: number,
  cambios: ActualizarDestinatarioAvisoVentaDto,
): Promise<DestinatarioAvisoVenta> {
  return pedir<DestinatarioAvisoVenta>(`/admin/avisos-venta/${id}`, {
    metodo: 'PATCH',
    cuerpo: cambios,
  });
}

export function quitarDestinatarioAvisoVenta(id: number): Promise<void> {
  return pedir<void>(`/admin/avisos-venta/${id}`, { metodo: 'DELETE' });
}
